import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import ReadyToShipList from './ReadyToShipList'
import ReadyToShipEdit from './ReadyToShipEdit'

export default {
    list: ReadyToShipList,
    edit: ReadyToShipEdit,
    icon: ThumbUpIcon,
};
